import { useAuth } from "react-oidc-context";
import React from "react";
import { useNavigate } from "react-router-dom";

type AccountConfirmationRedirectToHomeProps = {

}
// this component is used to redirect user to welcome page, when he is logged in. 
// Returns user to confirmation url but now user is logged in and redirected
export const AccountConfirmationRedirectToHome: React.FC<AccountConfirmationRedirectToHomeProps> = (props) => {
    const auth = useAuth();
  const navigate = useNavigate();

    React.useEffect(() => {
        const checkAuthentication = async () => {
          if (auth.isAuthenticated) {
            // User is authenticated, redirect to homepage
            navigate("/");
          } else {
            // User is not authenticated, initiate login
            auth.signinRedirect();
          }
        };
    
        checkAuthentication();
      }, [auth.isAuthenticated, navigate]);

    return <div></div>

}